"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_1 = require("gatsby");
function mapToBreadcrumbProps(props) {
    const breadcrumbs = {
        crumbs: null,
        path: props.pagePath,
        siteURL: props.siteURL,
        removeTrailingSlashes: true,
        CustomLink: gatsby_1.Link,
    };
    /**
     * If using custom breadcrumbs, then last breadcrumb is the current page and its
     * short name. unless no short name is given then use the url.
     */
    if (props.customBreadcrumbs?.length) {
        let curPageShortName = props.pagePath.split('/')?.pop()?.replaceAll('-', ' ') || '';
        if (props.shortName)
            curPageShortName = props.shortName;
        const formattedBreadcrumbs = [];
        for (const crumb of props.customBreadcrumbs) {
            if (typeof crumb === 'number')
                continue;
            formattedBreadcrumbs.push(formatBreadcrumb(crumb));
        }
        formattedBreadcrumbs.push({
            path: props.pagePath,
            shortName: curPageShortName,
        });
        breadcrumbs.crumbs = formattedBreadcrumbs;
    }
    return breadcrumbs;
}
function formatBreadcrumb(crumb) {
    return {
        path: crumb.pagePath,
        shortName: crumb.shortName
            ? crumb.shortName
            : crumb.pagePath.split('/')?.pop()?.replaceAll('-', ' ') || '',
    };
}
exports.default = mapToBreadcrumbProps;
